// @ts-nocheck
import React from 'react'
import { NavLink } from 'redux-first-router-link'
import cx from 'classnames'
import { t } from 'ttag'

import { FadeScale } from 'components/shared/Transitions/FadeScale/FadeScale'

import EBHRIcon from 'images/ebhr-logo-white.svg'

import styles from './Logo.module.scss'

const IconLogo = ({ className = undefined, isInitialised }) => {
  const ref = React.useRef()

  return (
    <FadeScale
      className={cx(styles.icon, { [className]: Boolean(className) })}
      {...{ ref, isInitialised }}
    >
      <img alt="EBHR" ref={ref} src={EBHRIcon} />
    </FadeScale>
  )
}

const TextLogo = ({ className = undefined, isInitialised }) => {
  const ref = React.useRef()

  return (
    <FadeScale
      className={cx(styles.text, {
        [className]: Boolean(className),
      })}
      {...{ ref, isInitialised }}
    >
      <span ref={ref}>
        <span className={styles.prefix}>EBBER</span>
        <span className={styles.suffix}>{t`selection`}</span>
      </span>
    </FadeScale>
  )
}

export const Logo = ({
  className = undefined,
  redirectTo,
  isCollapsed,
  isTransparent,
}) => (
  <NavLink
    className={cx(styles.logo, {
      [styles.collapsed]: isCollapsed,
      [styles.transparent]: isTransparent,
      [className]: Boolean(className),
    })}
    to={redirectTo}
  >
    <IconLogo isInitialised={isCollapsed} />
    <TextLogo isInitialised={!isCollapsed} />
  </NavLink>
)
